import { useQuery } from "react-query";
import { getChecklist } from "services/api/checklist/checklistApi";

const api = {
  fetchCheckListByProject: async (projectId: number) => {
    const { data } = await getChecklist(projectId);
    return data;
  },
};

export const useFetchCheckListByProject = (projectId: number) => {
  const { isLoading: checklistLoading, data: checklistData } = useQuery(
    ["checklistByProject", projectId],
    () => api.fetchCheckListByProject(projectId),
    {
      staleTime: Infinity,
      retry: (failureCount, error) => {
        // Não tenta novamente se o erro for 400 (Bad Request)
        if (error && typeof error === 'object' && 'response' in error && 
            error.response && typeof error.response === 'object' && 'status' in error.response &&
            error.response.status === 400) {
          return false;
        }
        // Para outros erros, permite até 3 tentativas
        return failureCount < 3;
      },
    }
  );

  return {
    checklistLoading,
    checklistData,
  };
};
